
import React from 'react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-user-add-line',
      title: 'Lead Generation AI',
      description: 'Intelligent systems that identify, qualify, and engage prospects automatically.',
      image: 'https://public.readdy.ai/ai/img_res/1d3dddb5cce58eb0f784a64d347e354c.jpg'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Process Automation',
      description: 'Streamline operations with intelligent workflow automation.',
      image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20abstract%20design%20with%20white%20background%2C%20simple%20geometric%20workflow%20patterns%2C%20subtle%20gray%20lines%20and%20shapes%2C%20modern%20process%20visualization%2C%20Apple-inspired%20simplicity%2C%20no%20text%20or%20complex%20elements&width=400&height=300&seq=process-minimal&orientation=landscape'
    },
    {
      icon: 'ri-heart-line',
      title: 'Client Experience',
      description: 'Personalized interactions that build lasting relationships.',
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20design%20with%20pure%20white%20background%2C%20soft%20geometric%20shapes%20representing%20connection%2C%20subtle%20light%20blue%20accents%2C%20clean%20modern%20aesthetic%2C%20Apple-inspired%20simplicity%2C%20no%20text%20or%20detailed%20graphics&width=400&height=300&seq=client-minimal&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-20">
          <h3 className="text-4xl md:text-5xl font-light text-black mb-6 tracking-tight">
            What we do
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light leading-relaxed">
            AI solutions designed to transform how your business operates
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-12">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group text-center"
            >
              <div className="mb-8">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-64 object-cover rounded-3xl mb-8"
                />
                <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${service.icon} text-lg text-white`}></i>
                </div>
              </div>
              
              <h4 className="text-2xl font-medium text-black mb-4 tracking-tight">
                {service.title}
              </h4>
              
              <p className="text-gray-600 text-lg leading-relaxed font-light">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
